import React from 'react'
import { Modal } from 'antd'
import CustomButton from '../CustomButton'
import { deletefreeuser, getfreeuser } from '../../redux/actions/freeuserAction';



const DeleteUsermodal = ({ visible, onClose,setNotificationmodal,checked,setchecked,multieditfreeuser}) => {
  const cancel = () => {
    // setPlayerInfo({})
    onClose()
  }

const onsave=async()=>{

try {

  if (checked.length > 0){

    const validusers = checked.filter(id => typeof id === 'string');   
    let payload={
      ids:validusers
    }
    const res= await deletefreeuser(payload)
  if (res?.data){

    setchecked([])
    if ( multieditfreeuser && multieditfreeuser?.length > 0){
      
      window.location.reload()
    }
    cancel()
      let organizationid = localStorage.getItem("organizationid");
        let payload = { organizationid };
    
        await getfreeuser(payload);
   }
  }
  
} catch (error) {

  console.log('error',error);
  
}
 
}
  


  return (
    <Modal
      className='deletemodal'
      title=''
      open={visible}
      onCancel={onClose}
      centered
     footer={[

        
      ]}
      
    >

   
<h1>
   Delete User?
</h1>



{/* <p>
 Do you want to delete this user
</p> */}


<p>
  Do you want to delete {multieditfreeuser?.length > 0 ? `${multieditfreeuser.length} Users` : 'this User'}?
</p>


<div className='btn'>

   <CustomButton onClick={onsave} text={'Yes'}/>


   <CustomButton onClick={cancel} text={'No'}/>
 
</div>
    </Modal>




  )
}

export default DeleteUsermodal
